module.exports = __webpack_public_path__ + "static/img/hammer.458875a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smashing-golden-eggs/hammer.png
// module id = RGtH
// module chunks = 215